if (!customElements.get('free-shipping-progress')) {
  customElements.define(
    'free-shipping-progress',
    class FreeShippingProgress extends HTMLElement {
      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());

        // Product page: preview the quantity selector. Delegated because variant changes re-render the input.
        if (this.dataset.quantityInput) {
          this.onQuantityChange = (event) => {
            if (event.target.id === this.dataset.quantityInput) this.render();
          };
          document.addEventListener('change', this.onQuantityChange);
          document.addEventListener('input', this.onQuantityChange);
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.onQuantityChange) {
          document.removeEventListener('change', this.onQuantityChange);
          document.removeEventListener('input', this.onQuantityChange);
        }
      }

      get pending() {
        if (this.dataset.productQualifies !== 'true') return 0;
        const input = document.getElementById(this.dataset.quantityInput);
        const value = parseInt(input ? input.value : this.dataset.defaultQuantity, 10);
        return value > 0 ? value : 0;
      }

      refresh() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const next = html.querySelector('.free-shipping-progress');
            const current = this.querySelector('.free-shipping-progress');

            if (!next || !current) {
              this.innerHTML = next ? next.outerHTML : '';
              return;
            }

            current.dataset.cartCount = next.dataset.cartCount;
            current.dataset.threshold = next.dataset.threshold;
            this.render();
          })
          .catch((e) => {
            console.error(e);
          });
      }

      // Update in place so the bar widths transition and the live region is announced
      render() {
        const progress = this.querySelector('.free-shipping-progress');
        if (!progress) return;

        const messages = JSON.parse(progress.querySelector('.free-shipping-progress__messages').textContent);
        const threshold = parseInt(progress.dataset.threshold, 10);
        const cartCount = parseInt(progress.dataset.cartCount, 10);
        const total = cartCount + this.pending;
        const reached = cartCount >= threshold;

        let message;
        if (reached) {
          message = messages.reached;
        } else if (total >= threshold) {
          message = messages.addToCart;
        } else if (total === 0) {
          message = messages.start;
        } else {
          message = messages.remaining[threshold - total - 1];
        }

        const text = progress.querySelector('.free-shipping-progress__text');
        text.textContent = message;
        if (reached) text.insertAdjacentHTML('beforeend', ' <span aria-hidden="true">🎉</span>');
        progress.classList.toggle('free-shipping-progress--reached', reached);

        const percent = (count) => `${Math.floor((Math.min(count, threshold) * 100) / threshold)}%`;
        progress.querySelector('.free-shipping-progress__fill').style.width = percent(cartCount);
        progress.querySelector('.free-shipping-progress__pending').style.width = percent(total);
        progress
          .querySelector('.free-shipping-progress__track')
          .setAttribute('aria-valuenow', Math.min(cartCount, threshold));
      }
    }
  );
}
